require("leaflet");
class map {
  init() {
    const $map = document.querySelector(".map-container");

    const map = L.map("map", {
      scrollWheelZoom: false,
      tap: false
    }).setView([$map.dataset.latitude, $map.dataset.longitude], 17);

    // L.tileLayer(
    //   "https://maps.heigit.org/openmapsurfer/tiles/roads/webmercator/{z}/{x}/{y}.png"
    // ).addTo(map);
    // L.tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}{r}.png').addTo(map)
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    let myIcon = L.icon({
      iconUrl: "/dist/img/ico/pin.png",
      iconSize: [50, 50],
      iconAnchor: [25, 25]
    });

    L.marker([$map.dataset.latitude, $map.dataset.longitude], { icon: myIcon })
      .addTo(map)
      .bindPopup($map.dataset.address);
  }
}
export default map;
